// extracted by mini-css-extract-plugin
export var designation = "LinkedinCard-module--designation--gMpfy";
export var image = "LinkedinCard-module--image--Sp-wj";
export var linkedinImage = "LinkedinCard-module--linkedin-image--GdUHG";
export var memberCard = "LinkedinCard-module--member-card--buHi7";
export var memberImageContainer = "LinkedinCard-module--member-image-container--f2e0f";
export var name = "LinkedinCard-module--name--U84eU";